import React,{ useEffect,useState } from 'react';
import DataReactTable from "./DataReactTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {connect} from "react-redux";
import ModelProduct from '../../../../../../Models/Product';
import { faUserSlash } from '@fortawesome/fontawesome-free-solid';
import {showNotification} from "../../../../../../shared/components/Notification";


const PriceTrackerTable = ({ dispatch, priceTrackerData ,theme,rtl}) => {

    const [isTableLoaded,setLoaded] = useState(false);
    const vm = new ModelProduct();

    useEffect(()=>{
        setLoaded(false);
        if(typeof priceTrackerData !== 'undefined' || priceTrackerData!==null)
            setLoaded(true);

    },[priceTrackerData]);

    const columns =[
        // {
        //     width: 300,
        //     Header: "Options",
        //     Cell: ({ cell }) => {
        //          // debugger
        //         return (
        //             <a href={"/s/"+cell.row.original.qr_id} className={ "btn btn-danger btn-sm m-0 mr-2 pt-1 pb-1 pl-2 pr-2"} onClick={e => {e.preventDefault(); removeMemberAccess(cell.row.original)}}>
        //                 Remove <FontAwesomeIcon icon={faUserSlash}/>
        //             </a>
        //         )
        //     }
        // },
        {
            Header: 'Amount',
            accessor: 'pt_amount'
        },{
            Header: 'Date',
            accessor: 'pt_created',
            width: 150
        }
    ];

    const tableStructure= {
        tableHeaderData: columns
    };

    return (


            <div>
                {isTableLoaded &&
                    <DataReactTable reactTableData={ tableStructure } />
                }
            </div>

    );
};

export default connect(state => ({
    data:state.product.productData,
    priceTrackerData:state.product.priceTrackerData,
    rtl: state.rtl,
    theme: state.theme
}))(PriceTrackerTable);
